import React from 'react'
import './style.css';
function Main() {
  return (
    <div class="main">
        <p>Create Your</p>
        <h1>T-shirt Design</h1>
        <button> Get Started</button>
        <h3>View how it works</h3>
        <span>lorem uhgdiu quigdiqe ddlk  dgqidf</span>
    </div>
  )
}

export default Main